<template>
    <div
        class="min-w-[250px] flex flex-col gap-5 px-4 pb-4 items-center"
    >
        <p class="text-sm text-center" v-if="desc" v-html="desc" />

        <slot name="current" />
        <ul v-if="features?.length" class="flex flex-col gap-3 self-start w-[470px]">
            <li v-for="(feature, key) in features" :key="key" class="flex text-sm text-grey-450 gap-1">
                <PtIcon
                    :icon="SolidTickCircle"
                    class="th-btn-icon text-xl fill-eureka-500 flex-shrink-0"
                />
                {{ feature }}
            </li>
        </ul>
        <div>
            <img v-if="img" class="w-[460px] h-[260px] mx-[50px]" :src="img" />
        </div>
        <div class="relative mt-4">
            <slot name="button" />
            <button @click="handleClick" class="th-btn px-[130px]" :class="highlight ? 'th-btn-primary' : 'th-btn-secondary'">
                {{ t(`packageDiff.${type}.buttonText`) }}
            </button>
        </div>
        <div @click="emits('close')" class="cursor-pointer text-grey-450 hover:underline">
            {{ t(`packageDiff.${type}.continue`) }}
        </div>
    </div>
</template>

<script setup lang="ts">
import { PtIcon } from 'patsnap-biz';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { EditionType } from '../../constants';
import { cn, en, jp, tw } from '../../infrastructure/locales';
import type { EurekaPackageType } from '@eureka/services/src/apis/common.api.types';

import SolidTickCircle from '@patsnap-ui/icon/assets/solid/TickCircle.svg';

const { t, te, tm } = useI18n({
    messages: {
        cn, en, jp, tw,
    },
});
const props = defineProps<{
  type: EditionType,
  highlight: boolean,
  packageType: EurekaPackageType,
  version: string,
  features?: string[],
}>();

const emits = defineEmits<{
    (event: 'choose', isPremium: boolean): void,
    (event: 'close'): void,
}>();

const packageKey = `packageDiff.${props.type}.packages.${props.packageType}`;
const versionKey = `packageDiff.${props.type}.versions.${props.version}`;

const features = computed(() => {
    if (props.features?.length) {
        return props.features;
    }
    if (te(`${packageKey}.features`)) {
        return tm(`${packageKey}.features`);
    }
    if (te(`${versionKey}.features`)) {
        return tm(`${versionKey}.features`);
    }
    return [];
})

const desc = computed(() => {
    if (te(`${packageKey}.description`)) {
        return t(`${packageKey}.description`);
    }
    if (te(`${versionKey}.description`)) {
        return t(`${versionKey}.description`);
    }
    return '';
});

const img = computed(() => {
    return '';
})

function handleClick() {
    emits('choose', props.type === EditionType.PREMIUM);
}
</script>
